import React, { useEffect, useState } from 'react';
import { CircularProgress, IconButton, TextField, InputAdornment, Avatar } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ArrowForwardIos } from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';
import InfiniteScroll from 'react-infinite-scroll-component';
import './rooms.css';
import { getRoomsEnrollStd } from '@/app/services/rooms/rooms';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import PageHeader from '@/app/customComponents/PageHeader';
import { useNavigate } from 'react-router-dom';

const Rooms = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [searchQuery, setSearchQuery] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [rows, setRows] = useState([]);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleGoToRoom = (row) => {
		navigate(`/checkinout/${row.id}`, {
			state: row,
		});
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getRoomsEnrollStd(searchQuery, page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	useEffect(() => {
		let isMounted = true;
		const id = setTimeout(
			() => {
				setIsLoading(true);
				setFirstLoad(false);
				getRoomsEnrollStd(searchQuery, 1)
					.then((res) => {
						if (!isMounted) return;
						if (res.data.last_page > res.data.current_page) {
							setHasMore(true);
						} else {
							setHasMore(false);
						}
						setPage(res.data.current_page + 1);
						setRows(res.data.data);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							}),
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000,
		);
		return () => {
			isMounted = false;
			clearTimeout(id);
		};
	}, [dispatch, searchQuery]);

	return (
		<div className="mt-16 md:mt-32 w-11/12 max-w-3xl mx-auto overflow-hidden">
			<div className="flex justify-between sm:items-center sm:flex-row flex-col ">
				<PageHeader hasBack={false} title="Rooms" />

				<TextField
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									onClick={() => {
										document.getElementById('search').focus();
									}}
								>
									<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
								</IconButton>
							</InputAdornment>
						),
					}}
					className="sm:max-w-400"
					fullWidth
					id="search"
					label="Search"
					onChange={handleSearch}
					value={searchQuery}
				/>
			</div>

			<TableContainer className="rooms-table-cont shadow-card rounded-8" component={Paper} id="Scrollable-table">
				<Table className="rooms-table" stickyHeader style={{ width: '100%' }}>
					<TableHead>
						<TableRow>
							<TableCell className="bg-white checkinout-table-header">Rooms</TableCell>
							<TableCell align="center" className="bg-white checkinout-table-header" width={100}>
								Students
							</TableCell>
							<TableCell align="right" className="bg-white checkinout-table-header" />
						</TableRow>
					</TableHead>
					<TableBody className="">
						{isLoading ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : !rows.length && !firstLoad ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									No Rooms
								</TableCell>
							</TableRow>
						) : (
							rows?.map((row) => (
								<TableRow key={row.id} onClick={() => handleGoToRoom(row)} style={{ cursor: 'pointer' }}>
									<TableCell>
										<div className="flex items-center">
											<Avatar alt="student-face" className="mr-16" src={row.thumb} />
											<div className="rooms-school-name">{row.name}</div>
										</div>
									</TableCell>
									<TableCell align="center" width={100}>
										<div className="rooms-student-count">{row.students_count}</div>
									</TableCell>
									<TableCell align="right" width={50}>
										<ArrowForwardIos style={{ color: 'grey', fontSize: '14px' }} />
									</TableCell>
								</TableRow>
							))
						)}
						{fetchingMore ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : null}
					</TableBody>
				</Table>
			</TableContainer>
			<InfiniteScroll
				dataLength={rows.length}
				hasMore={hasMore}
				next={handleLoadMore}
				scrollableTarget="Scrollable-table"
			/>
		</div>
	);
};

export default Rooms;
